import { render, staticRenderFns } from "./PageProfileEditView.vue?vue&type=template&id=66a45aa9&"
import script from "./PageProfileEditView.vue?vue&type=script&lang=ts&"
export * from "./PageProfileEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports